<!-- Replace with list component once there is such in the ui kit -->
<div class="wrapper centered-vert justify-cont-sb sp-px-20 sp-py-10" *ngFor="let account of approvedAccounts" (click)="switchAccount(account)">
  <div class="centered-vert">
    <i class="sp-mr-4 text-color-success-6" [style.visibility]="isAccountCurrent(account.accountId) ? 'visible' : 'hidden'" ui-icon uiType="check"></i>
    <span class="account-name" [class.current]="isAccountCurrent(account.accountId)">{{ account.accountName }}</span>
  </div>
  <span class="domain">{{ account.accountDomain }}</span>
</div>
